import { FC } from 'react';

import { ResultSearchType } from '@savgroup-front-common/core/molecules/SearchWithDimmer/SearchWithDimmer.types';
import { Sheet, SheetContent } from '@savgroup-front-common/primitive/ui/sheet';
import { RESULT_TYPE } from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

import { AppBarSearchPanel } from '../AppBarSearchPanel/AppBarSearchPanel';

interface AppBarSearchSheetProps {
  isOpen: boolean;
  onClose: () => void;
  query?: string;
  isLoading: boolean;
  isFetchingMore: boolean;
  focusedResultType?: RESULT_TYPE;
  results: SearchResultList<ResultSearchType>[];
  onSearch: (value: string) => void;
  onShowMore: (resultType: RESULT_TYPE) => void;
}

export const AppBarSearchSheet: FC<AppBarSearchSheetProps> = ({
  isOpen,
  onClose,
  query = '',
  isLoading,
  isFetchingMore,
  focusedResultType,
  results,
  onSearch,
  onShowMore,
}) => {
  return (
    <Sheet
      open={isOpen}
      onOpenChange={(isSheetOpen) => {
        if (!isSheetOpen) {
          onClose();
        }
      }}
    >
      <SheetContent
        side="top"
        className={
          'data-[side=top]:top-12 data-[side=top]:h-[calc(100vh-48px)] ' +
          'gap-0 overflow-y-auto px-4 pt-14 pb-4'
        }
        data-testid="appBar_searchSheet"
      >
        <AppBarSearchPanel
          query={query}
          isLoading={isLoading}
          isFetchingMore={isFetchingMore}
          focusedResultType={focusedResultType}
          results={results}
          onSearch={onSearch}
          onShowMore={onShowMore}
          onSelectResult={onClose}
          inputDataTestId="appBarSearchSheetInput"
          clearDataTestId="appBarSearchSheetClear"
        />
      </SheetContent>
    </Sheet>
  );
};
